import type { UUID } from "@/Shared/types";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

import { useNavigate } from "react-router-dom";
import BookShipmentError from "./CustomComponents/BookShipmentError";

interface BookShipmentNearlyDoneScreenProps {
  shipmentId: UUID;
}

export function BookShipmentNearlyDoneScreen(
  props: BookShipmentNearlyDoneScreenProps,
) {
  const navigate = useNavigate();

  function navigateToShipment() {
    navigate("/view-shipment?shipmentId=" + props.shipmentId);
  }
  return (
    <Stack gap={8} align="center">
      <BookShipmentError />
      <Button primary onClick={navigateToShipment}>
        View Shipment
      </Button>
    </Stack>
  );
}
